// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-wrapper ul {
  list-style-type: none;
  padding-left: 0;
}
.sidebar-wrapper .sidebar-mobile {
  display: block;
}
.sidebar-wrapper nav.sidebar {
  width: 30rem;
  display: none;
  padding: 1.5rem;
}
.sidebar-wrapper nav.sidebar li.item:first-child {
  border-top: 0.1rem solid lightgrey;
}
.sidebar-wrapper nav.sidebar li.item {
  border-radius: 0.3rem;
  padding: 1.5rem 1.5rem 1.5rem 2rem;
  border-left: 0.1rem solid lightgrey;
  border-bottom: 0.1rem solid lightgrey;
  border-right: 0.1rem solid lightgrey;
  color: yellow;
  background: lightgray;
  box-shadow: 1rem 1rem 0.5rem #e8e8e8;
}
.sidebar-wrapper nav.sidebar li.item:hover,
.sidebar-wrapper nav.sidebar li.item.active {
  background: grey;
  color: white;
  text-decoration: none;
}
@media (min-width: 768px) {
  .sidebar-wrapper .sidebar-mobile {
    display: none;
  }
  .sidebar-wrapper nav.sidebar {
    display: inline-block;
  }
  .sidebar-wrapper .page-content {
    display: inline-block !important;
    width: calc(100% - 31.5rem) !important;
    padding: 1.5rem 0 1.5rem 0 !important;
  }
}
.sidebar-wrapper .page-content {
  display: block;
  width: 100%;
  padding: 0.5rem;
  vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/Components/Layout/ApplicationNavigation/SideBar/SideBar.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;EACA,eAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAFJ;AAII;EACE,kCAAA;AAFN;AAKI;EACE,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,qCAAA;EACA,oCAAA;EACA,aAAA;EACA,qBAAA;EACA,oCAAA;AAHN;AAMI;;EAEE,gBAAA;EACA,YAAA;EACA,qBAAA;AAJN;AAQE;EACE;IACE,aAAA;EANJ;EAQE;IACE,qBAAA;EANJ;EASE;IACE,gCAAA;IACA,sCAAA;IACA,qCAAA;EAPJ;AACF;AAUE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AARJ","sourcesContent":[".sidebar-wrapper {\n  ul {\n    list-style-type: none;\n    padding-left: 0;\n  }\n\n  .sidebar-mobile {\n    display: block;\n  }\n\n  nav.sidebar {\n    width: 30rem;\n    display: none;\n    padding: 1.5rem;\n\n    li.item:first-child {\n      border-top: 0.1rem solid lightgrey;\n    }\n\n    li.item {\n      border-radius: 0.3rem;\n      padding: 1.5rem 1.5rem 1.5rem 2rem;\n      border-left: 0.1rem solid lightgrey;\n      border-bottom: 0.1rem solid lightgrey;\n      border-right: 0.1rem solid lightgrey;\n      color: yellow;\n      background: lightgray;\n      box-shadow: 1rem 1rem 0.5rem #e8e8e8;\n    }\n\n    li.item:hover,\n    li.item.active {\n      background: grey;\n      color: white;\n      text-decoration: none;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .sidebar-mobile {\n      display: none;\n    }\n    nav.sidebar {\n      display: inline-block;\n    }\n\n    .page-content {\n      display: inline-block !important;\n      width: calc(100% - 31.5rem) !important;\n      padding: 1.5rem 0 1.5rem 0 !important;\n    }\n  }\n\n  .page-content {\n    display: block;\n    width: 100%;\n    padding: 0.5rem;\n    vertical-align: top;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
